import { render, staticRenderFns } from "./publicTemp.vue?vue&type=template&id=5cbec7b0&scoped=true&"
import script from "./publicTemp.vue?vue&type=script&lang=js&"
export * from "./publicTemp.vue?vue&type=script&lang=js&"
import style0 from "./publicTemp.vue?vue&type=style&index=0&id=5cbec7b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbec7b0",
  null
  
)

export default component.exports